import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import { Container, Button, Box, Stack, Grid } from "@mui/material";
import Breadcrums from "components/Breadcrumbs";
import { useState, useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { TextBox } from "devextreme-react/text-box";
import Divider from "@mui/material/Divider";
import { Checkbox, CheckboxGroup } from "rsuite";
import PropertyService from "API/PropertyService";
import activitiesData from "../catalogs/GetActivities";
import zonesData from "../catalogs/GetZones";
import propertyData from "../catalogs/GetTypes";
import suburbData from "../catalogs/GetSuburbs";
import convert from "./scripts/convert";
import "./Style/styles.css";

function SearchProperty() {
  const [activity] = activitiesData();
  const [zones] = zonesData();
  const [types] = propertyData();
  const [suburbs] = suburbData();
  /// /////////////////////////// CREATE QUERY IN URL ////////////////////////////////////
  const history = useNavigate();
  const addQuery = (key, value) => {
    const { pathname } = window.location;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    history({
      pathname,
      search: searchParams.toString().replace(/%2C/g, ","), // unescape
    });
    window.location.reload();
  };
  /// /////////////////////////// READ URL PARAMETERS ////////////////////////////////////
  function useQuery() {
    return useMemo(() => new URLSearchParams(window.location.search));
  }
  const query = useQuery();
  /// /////////////////////////// FILTERS ////////////////////////////////////
  const [type, setType] = useState(query.get("type") || "all");
  const [zone, setZone] = useState(query.get("zone") ? convert(query.get("zone")) : []);
  const [businessActivity, setBusinessActivity] = useState(
    query.get("business_activity") ? convert(query.get("business_activity")) : []
  );
  const [propertyType, setPropertyType] = useState(
    query.get("propertytype") ? convert(query.get("propertytype")) : []
  );
  const [suburb, setSuburb] = useState(query.get("suburb") ? convert(query.get("suburb")) : []);
  const [searchField, setSearchField] = useState(query.get("q") || "");
  useEffect(() => {
    if (
      businessActivity.length === 0 &&
      propertyType.length === 0 &&
      zone.length === 0 &&
      suburb.length === 0 &&
      searchField.length === 0
    ) {
      setType("all");
    } else {
      setType("type");
    }
  }, [businessActivity, propertyType, zone, suburb, searchField]);
  /// /////////////////////////// FILTERS ////////////////////////////////////
  // Business Activity
  const handleChangeActivity = (value) => {
    setBusinessActivity(value);
    addQuery("business_activity", value);
    addQuery("p", 1);
  };
  // Property type
  const handleChangePropertyType = (value) => {
    setPropertyType(value);
    addQuery("propertytype", value);
    addQuery("p", 1);
  };
  // zones type
  const handleChangeZones = (value) => {
    setZone(value);
    addQuery("zone", value);
    addQuery("p", 1);
  };
  // Suburb type
  const handleChangeSuburb = (value) => {
    setSuburb(value);
    addQuery("suburb", value);
    addQuery("p", 1);
  };
  // handle term
  const handleTerm = () => {
    setType("term");
    addQuery("q", searchField);
    addQuery("p", 1);
  };
  /// /////////////////////////// ON TERM CHANGE ////////////////////////////////////
  const valueChange = (term) => {
    if (term.length === 0) {
      setSearchField("");
      addQuery("q", "");
      addQuery("p", 1);
    }
    setSearchField(term);
  };
  const onEnterKey = () => {
    setType("term");
    addQuery("q", searchField);
    addQuery("p", 1);
  };
  /// /////////////////////////// CLEAR FILTERS ////////////////////////////////////
  const handleClear = (value, checked) => {
    setBusinessActivity(checked ? businessActivity : []);
    setPropertyType(checked ? propertyType : []);
    setZone(checked ? zone : []);
    setSuburb(checked ? suburb : []);
    setType("All");
    setSearchField("");
    addQuery("p", 1);
    history.replace("/search");
  };
  return (
    <>
      <MKBox minHeight="25rem" width="100%">
        <MKBox
          color="black"
          variant="gradient"
          p={1}
          position="relative"
          sx={{
            backgroundColor: "#FFF",
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
          }}
        >
          <div style={{ position: "relative", width: "50%" }} className="dx-field-label">
            <div style={{ display: "flex" }}>
              <div
                style={{
                  padding: "5px",
                  height: "50px",
                  borderRight: "1px solid #E5E5E5",
                  borderRadius: "70% 1% 0% 70%",
                  borderLeft: "1px solid #E5E5E5",
                  borderTop: "1px solid #E5E5E5",
                  borderBottom: "1px solid #E5E5E5",
                }}
              >
                <MKTypography variant="button" color="text">
                  <span className="material-icons-outlined">search</span>
                </MKTypography>
              </div>
              <div
                style={{
                  flexGrow: "1",
                  height: "50px",
                  marginRight: "10px",
                  border: "1px solid #E5E5E5",
                  borderLeft: "0",
                  borderRadius: "0 25px 25px 0px",
                }}
              >
                <TextBox
                  placeholder="Buscar..."
                  showClearButton
                  value={searchField}
                  onValueChange={valueChange}
                  onEnterKey={onEnterKey}
                  style={{
                    padding: "5px",
                    fontSize: "18px",
                    height: "50px",
                    border: "0px rgba(0, 0, 0, 0)",
                    backgroundColor: "rgba(0, 0, 0, 0)",
                  }}
                />
              </div>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ color: "#F6F6F6", height: "46px", borderRadius: "25px" }}
                  onClick={handleTerm}
                >
                  <MKTypography variant="body2" color="white">
                    Buscar
                  </MKTypography>
                </Button>
              </div>
            </div>
          </div>
        </MKBox>
        <MKBox component="section" bgColor="white" py={4}>
          <Container>
            <Grid container spacing={1} item xs={12} lg={12} mx="auto">
              <Grid item xs={4}>
                <Breadcrums
                  routes={[
                    { label: "Inicio", route: "/" },
                    { label: "Bienes Inmuebles", route: "#" },
                    { label: "Buscador de Inmuebles", route: "#" },
                  ]}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
        <MKBox
          component="section"
          position="relative"
          variant="contained"
          sx={{
            display: "grid",
            placeItems: "Center",
            backgroundSize: "cover",
            backgroundColor: "#FFF",
            width: "100%",
          }}
        >
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} lg={3} py={2}>
                <Grid item position="relative" className="options" height="auto">
                  <Box m={2}>
                    <MKTypography
                      variant="button"
                      color="text"
                      fontWeight="bold"
                      textTransform="uppercase"
                    >
                      <br />
                    </MKTypography>
                    <Stack direction="row" justifyContent="end">
                      <Link activeClassName="active-style" to="/search" onClick={handleClear}>
                        Limpiar filtros
                      </Link>
                    </Stack>
                  </Box>
                  <div className="option">
                    <MKTypography variant="body2" color="text" fontWeight="bold">
                      Actividad Económica
                    </MKTypography>
                    <MKTypography variant="body2" color="text">
                      <CheckboxGroup
                        inline
                        name="activityP[]"
                        onChange={handleChangeActivity}
                        value={businessActivity}
                      >
                        {activity.map((item) => (
                          <>
                            <Checkbox key={item.id} value={item.id} checked>
                              &nbsp;&nbsp;{item.name}
                            </Checkbox>
                          </>
                        ))}
                      </CheckboxGroup>
                    </MKTypography>
                  </div>
                  <Divider orientation="horizontal" flexItem />
                  <div className="option">
                    <MKTypography variant="body2" color="text" fontWeight="bold">
                      Tipo
                    </MKTypography>
                    <MKTypography variant="body2" color="text">
                      <CheckboxGroup
                        inline
                        name="typesP[]"
                        onChange={handleChangePropertyType}
                        value={propertyType}
                      >
                        {types.map((item) => (
                          <>
                            <Checkbox key={item.id} value={item.id}>
                              &nbsp;&nbsp;{item.name}
                            </Checkbox>
                          </>
                        ))}
                      </CheckboxGroup>
                    </MKTypography>
                  </div>
                  <Divider orientation="horizontal" flexItem />
                  <div className="option">
                    <MKTypography variant="body2" color="text" fontWeight="bold">
                      Zona
                    </MKTypography>
                    <MKTypography variant="body2" color="text">
                      <CheckboxGroup
                        inline
                        name="zonesP[]"
                        onChange={handleChangeZones}
                        value={zone}
                      >
                        {zones.map((item) => (
                          <Checkbox key={item.id} value={item.id}>
                            &nbsp;&nbsp;{item.name}
                          </Checkbox>
                        ))}
                      </CheckboxGroup>
                    </MKTypography>
                  </div>
                  <Divider orientation="horizontal" flexItem />
                  <div className="option">
                    <MKTypography variant="body2" color="text" fontWeight="bold">
                      Colonia
                    </MKTypography>
                    <MKTypography variant="body2" color="text">
                      <CheckboxGroup
                        inline
                        name="suburbsP[]"
                        onChange={handleChangeSuburb}
                        value={suburb}
                      >
                        {suburbs.map((item) => (
                          <Checkbox key={item.id} value={item.id}>
                            &nbsp;&nbsp;{item.name}
                          </Checkbox>
                        ))}
                      </CheckboxGroup>
                    </MKTypography>
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} lg={9}>
                <PropertyService
                  type={type}
                  term={searchField}
                  zone={zone}
                  propertyType={propertyType}
                  businessActivity={businessActivity}
                  suburb={suburb}
                />
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </MKBox>
    </>
  );
}

export default SearchProperty;
